
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M15.41 86.25h89.18V108H15.41zM75.25 86.35v21.3M44.75 107.65v-21.3M28.68 86.59v21.36M91.32 86.59v21.36M82.45 77.88a34.58 34.58 0 10-45.08-.16M23.67 86.11l13.5-8.17h45.66l13.5 8.17M25.17 53.4h69.66M34.15 28.68h51.56M53.63 18.06l34.1 55M31.65 32.28l28.41 45.81M66.43 17.99L32.34 72.98M88.35 32.31L60.03 77.98"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M104.59 86.29V71.26L79.54 86.29M15.41 86.29V71.26l25.05 15.03"}})])
          )
        }
      }
    